<template>
  <section>
    <v-app style="background-color: #005a64;">
      <div style="width: 200px">
        <img class="logo" src="https://leverosintegra.com.br/Plus/arquivos/logo-leveros.png" alt="">
      </div>
      <!-- Financiamento Santander -->
      <v-card class="mt-5 mb-10 card-financiamento">
        <v-stepper v-model="stepPosition">
          <v-stepper-header>
            <v-stepper-step
              color="var(--standardGreen)"
              :complete="stepPosition > 1"
              step="1"
            >
              Início
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              color="var(--standardGreen)"
              :complete="stepPosition > 2"
              step="2"
            >
              Simulação
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" color="var(--standardGreen)">
              Proposta
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="etapaUm" lazy-validation>
                <div class="mb-2">
                  <h1 style="font-size: 1.4rem">Cliente</h1>
                  <div class="row">
                    <v-radio-group v-model="cliente.pessoaFisica" row>
                      <div class="col">
                        <v-radio :value="true" label="CPF" color="#005a64"></v-radio>
                      </div>
                      <div class="col">
                        <v-radio :value="false" label="CNPJ" color="#005a64"></v-radio>
                      </div>
                    </v-radio-group>
                  </div>
                  <div>
                    <label class="label" style="font-size: 0.95rem"
                      >{{ cliente.pessoaFisica ? "CPF" : "CNPJ" }}
                    </label>
                  </div>
                  <div>
                    <v-text-field
                      color="black"
                      v-model="cliente.documento"
                      v-mask="
                        cliente.pessoaFisica
                          ? '###.###.###-##'
                          : '##.###.###/####-##'
                      "
                      outlined
                      :rules="[
                        () => !!cliente.documento || 'Campo não preenchido',
                      ]"
                      required
                    ></v-text-field>
                  </div>
                  <div>
                    <label class="label" style="font-size: 0.95rem">{{
                      cliente.pessoaFisica
                        ? "Data de Nascimento"
                        : "Data de Fundação"
                    }}</label>
                  </div>
                  <div>
                    <!-- Date - Picker (Data de Nascimento / Fundação) -->
                    <v-text-field
                      color="black"
                      outlined
                      v-model="dataNascFundForm"
                      :rules="[
                        () => !!dataNascFundForm || 'Campo não preenchido',
                      ]"
                      v-mask="'##/##/####'"
                      persistent-hint
                    ></v-text-field>
                    <!-- <v-menu
                      ref="controlDateNascFund"
                      v-model="controlDateNascFund"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          single-line
                          label="Clique para selecionar a data"
                          v-model="dataNascFundForm"
                          :rules="[
                            () => !!dataNascFundForm || 'Campo não preenchido',
                          ]"
                          persistent-hint
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :show-current="false"
                        locale="pt-BR"
                        v-model="dataNascFund"
                        no-title
                        @input="controlDateNascFund = false"
                      ></v-date-picker>
                    </v-menu> -->
                  </div>

                  <div>
                    <div class="row">
                      <div class="col-2">
                        <div>
                          <label class="label" style="font-size: 0.95rem"
                            >DDD</label
                          >
                        </div>
                        <v-text-field
                          color="black"
                          v-model="cliente.ddd"
                          :rules="[() => !!cliente.ddd || '']"
                          maxlength="2"
                          outlined
                          required
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <div>
                          <label class="label" style="font-size: 0.95rem"
                            >Celular</label
                          >
                        </div>
                        <v-text-field
                          color="black"
                          v-model="cliente.telefone"
                          v-mask="'#####-####'"
                          :rules="[
                            () => !!cliente.telefone || 'Campo não preenchido',
                          ]"
                          outlined
                          required
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                  <br />
                  <h1 style="font-size: 1.4rem">Compra</h1>
                  <div>
                    <label class="label" style="font-size: 0.95rem"
                      >Valor da entrada</label
                    >
                  </div>
                  <div>
                    <v-text-field
                      color="black"
                      v-money="money"
                      v-model="valorEntrada"
                      :rules="[() => !!valorEntrada || 'Campo não preenchido']"
                      outlined
                      required
                    ></v-text-field>
                  </div>
                  <div>
                    <label class="label" style="font-size: 0.95rem"
                      >Valor da parcela</label
                    >
                  </div>
                  <div>
                    <v-text-field
                      color="black"
                      v-money="money"
                      ref="valorParcelas"
                      v-model.lazy="valorParcelas"
                      :rules="[() => !!valorParcelas || 'Campo não preenchido']"
                      outlined
                      required
                    ></v-text-field>
                  </div>
                  <div>
                    <label class="label" style="font-size: 0.95rem"
                      >Quantidade de parcelas</label
                    >
                  </div>
                  <div>
                    <v-select
                      v-model="quantidadeParcelas"
                      :rules="[
                        () =>
                          !!quantidadeParcelas.id ||
                          'Quantidade de parcelas não selecionado',
                      ]"
                      :items="installmentAmount"
                      return-object
                      item-value="id"
                      item-text="description"
                      disabled
                      outlined
                    ></v-select>
                  </div>
                  <div>
                    <label class="label" style="font-size: 0.95rem"
                      >Produto</label
                    >
                  </div>
                  <div>
                    <v-select
                      v-model="objetoFinanciado"
                      :items="financedObjects"
                      return-object
                      :rules="[
                        () =>
                          !!objetoFinanciado.id || 'Produto não selecionado',
                      ]"
                      item-value="id"
                      item-text="description"
                      :disabled="disablefinancedObjects"
                      outlined
                    ></v-select>
                  </div>

                  <!-- <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <h1 style="font-size: 1.4rem" class="mt-2">
                          Ofertas Santander
                        </h1>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <span>
                          Consulte o cliente sobre a permissão para os itens
                          abaixo. Importante informar que sem autorização o
                          cliente não receberá informações sobre determinados
                          produtos e serviços da Santander Financiamentos,
                          empresas do Grupo Santander e parceiros
                        </span>
                        <br /><br />
                        <div>
                          <strong
                            >Ofertas de produtos e serviços da Santander
                            Financiamentos.</strong
                          >
                        </div>
                        <div>
                          É a oportunidade de receber ofertas exclusivas de
                          produtos e serviços da Santander Financiamentos
                        </div>
                        <v-radio-group
                          v-model="radioOfertasSantander.santanderFinan"
                        >
                          <div class="row">
                            <div class="col">
                              <v-radio :value="1" label="Sim"></v-radio>
                            </div>
                            <div class="col">
                              <v-radio :value="2" label="Não"></v-radio>
                            </div>
                          </div>
                        </v-radio-group>
                        <br /><br />
                        <div>
                          <strong
                            >Compartilhamento de dados com o Grupo
                            Santander.</strong
                          >
                        </div>
                        <div>
                          É a oportunidade de receber ofertas de produtos e
                          serviços diretamento do Grupo Santander
                        </div>
                        <v-radio-group
                          v-model="radioOfertasSantander.grupoSantander"
                        >
                          <div class="row">
                            <div class="col">
                              <v-radio :value="1" label="Sim"></v-radio>
                            </div>
                            <div class="col">
                              <v-radio :value="2" label="Não"></v-radio>
                            </div>
                          </div>
                        </v-radio-group>
                        <br /><br />
                        <div>
                          <strong
                            >Compartilhamento de dados com empresas
                            parceiras.</strong
                          >
                        </div>
                        <div>
                          É a oportunidade de receber ofertas de produtos e
                          serviços das empresas parceiras do Grupo Santander
                        </div>
                        <v-radio-group
                          v-model="radioOfertasSantander.empresasParceiras"
                        >
                          <div class="row">
                            <div class="col">
                              <v-radio :value="1" label="Sim"></v-radio>
                            </div>
                            <div class="col">
                              <v-radio :value="2" label="Não"></v-radio>
                            </div>
                          </div>
                        </v-radio-group>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels> -->
                </div>
              </v-form>
              <br />

              <v-btn
                style="color: white"
                color="var(--standardGreen)"
                @click="enviaIdentificacao()"
              >
                Continuar
              </v-btn>

              <!-- <v-btn text @click="(stepPosition = 1), fechaFinanciamento()">
                Cancelar
              </v-btn> -->
            </v-stepper-content>

            <v-stepper-content step="2">
              <div class="row mb-2">
                <h1 style="font-size: 1rem" class="col-6 text-center">
                  {{ cliente.pessoaFisica ? "CPF" : "CNPJ" }}:
                  {{ cliente.documento }}
                </h1>
                <h1 style="font-size: 1rem" class="col-6 text-center">
                  Produto: {{ objetoFinanciado.description }}
                </h1>
              </div>
              <v-divider></v-divider>
              <div class="row mt-2">
                <div class="col text-center">
                  <div>Valor da Compra</div>
                  <div>
                    <!-- {{
                    //   (quantidadeParcelas.id *
                    //     parseFloat(limparNumeros(valorParcelas)) +
                    //     parseFloat(limparNumeros(valorEntrada)))
                    //     | toCurrency
                    // }} -->
                    {{parseFloat(ValorPedido) | toCurrency}}
                  </div>
                </div>
                <div class="col text-center">
                  <div>Entrada</div>
                  <div>
                    {{ parseFloat(limparNumeros(valorEntrada)) | toCurrency }}
                  </div>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col text-center">
                  <div>Parcelas</div>
                  <div>{{ quantidadeParcelas.description }}</div>
                </div>
                <div class="col text-center">
                  <div>Valor das parcelas</div>
                  <div>
                    {{ parseFloat(limparNumeros(valorParcelas)) | toCurrency }}
                  </div>
                </div>
              </div>
              <v-divider></v-divider>
              <div class="row mt-1">
                <div class="col">
                  <h1 style="font-size: 1.4rem" class="mt-2">Pagamento</h1>
                </div>
                <!-- <div class="col">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="float: right"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="var(--standardGreen)"
                        v-bind="attrs"
                        v-on="on"
                        @click="cupomDialog = true"
                      >
                        <v-icon dark> mdi-receipt </v-icon>
                      </v-btn>
                    </template>
                    <span>Cupom</span>
                  </v-tooltip>
                </div> -->
              </div>

              <v-form ref="etapaDoisA" lazy-validation>
                <div>
                  <label class="label" style="font-size: 0.95rem"
                    >Data de pagamento</label
                  >
                </div>
                <div>
                  <!-- Date - Picker (Data de Pagamento) -->
                  <v-menu
                    ref="controlDatePgto"
                    v-model="controlDatePgto"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    disabled
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="black"
                        outlined
                        readonly
                        v-model="dataPgtoForm"
                        :rules="[
                          () =>
                            !!dataPgtoForm ||
                            'Data de pagamento não selecionada',
                        ]"
                        persistent-hint
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @change="verificaAlteracaoDados()"
                      locale="pt-BR"
                      v-model="dataPgto"
                      :show-current="false"
                      :min="firstInstallment.minimumDate"
                      :max="firstInstallment.maximumDate"
                      no-title
                      @input="controlDatePgto = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div>
                  <label class="label" style="font-size: 0.95rem"
                    >Forma de pagamento</label
                  >
                </div>
                <div>
                  <v-select
                    @change="verificaAlteracaoDados()"
                    v-model="frmPagamentoSelecionada"
                    :items="paymentForms"
                    :rules="[
                      () =>
                        typeof frmPagamentoSelecionada === 'object'
                          ? !!frmPagamentoSelecionada.id
                          : !!frmPagamentoSelecionada ||
                            'Forma de pagamento não selecionada',
                    ]"
                    item-value="id"
                    item-text="description"
                    return-object
                    outlined
                  ></v-select>
                </div>
              </v-form>

              <v-form lazy-validation ref="etapaDoisB">
                <div
                  v-if="
                    typeof frmPagamentoSelecionada === 'object'
                      ? frmPagamentoSelecionada.id == 3
                      : frmPagamentoSelecionada == 3
                  "
                >
                  <h1 style="font-size: 1.4rem" class="mt-2">
                    Dados Bancários
                  </h1>
                  <label class="label" style="font-size: 0.95rem"
                    >Código da agência</label
                  >
                  <v-text-field
                    color="black"
                    v-model="codigoAgencia"
                    :rules="[
                      () =>
                        !!codigoAgencia || 'Código da agência não preenchido',
                    ]"
                    outlined
                    required
                  ></v-text-field>

                  <div class="row">
                    <div class="col">
                      <label class="label" style="font-size: 0.95rem"
                        >Conta</label
                      >
                      <v-text-field
                        color="black"
                        v-model="conta"
                        :rules="[() => !!conta || 'Conta não preenchida']"
                        outlined
                        required
                      ></v-text-field>
                    </div>
                    <div class="col">
                      <label class="label" style="font-size: 0.95rem"
                        >Dígito</label
                      >
                      <v-text-field
                        color="black"
                        v-model="digitoConta"
                        :rules="[
                          () =>
                            !!digitoConta || 'Dígito da conta não preenchido',
                        ]"
                        outlined
                        required
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </v-form>

              <!-- Informativos de simulação -->
              <div v-if="!simulacaoRealizada">
                <v-btn
                  block
                  color="var(--standardGreen)"
                  @click="enviaSimulacao()"
                  style="color: white"
                >
                  Simular
                </v-btn>
                <div class="mt-5">
                  <v-alert outlined type="info">
                    Realize a simulação para prosseguir!
                  </v-alert>
                </div>
              </div>


              <v-alert
                  outlined
                  type="success"
                  v-if="simulacaoRealizada"
                  class="pa-4"
              >
                Simulação realizada com sucesso! Clique em "CONTINUAR" para prosseguir.
              </v-alert>

              <!-- <v-card elevation="8" class="ma-3 pa-4" v-if="simulacaoRealizada">
                <h1 style="font-size: 1.4rem">Mais Informações</h1>
                <div class="row mt-2">
                  <div class="col text-center align-self-center">
                    <div>Valor liberado</div>
                  </div>
                  <div class="col text-center align-self-center">
                    <div>{{ parseFloat(releasedValue) | toCurrency }}</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col text-center align-self-center">
                    <div>Percentual de retenção sobre o valor liberado</div>
                  </div>
                  <div class="col text-center align-self-center">
                    <div>{{ retentionPercentage.toFixed(2) }}%</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col text-center align-self-center">
                    <div>Percentual de retenção sobre o valor de compra</div>
                  </div>
                  <div class="col text-center align-self-center">
                    <div>{{ retentitonPercentageAssets.toFixed(2) }}%</div>
                  </div>
                </div>
              </v-card> -->

              <br />

              <v-btn
                color="var(--standardGreen)"
                style="color: white"
                :disabled="!simulacaoRealizada"
                @click="buscaDadosProposta()"
              >
                Continuar
              </v-btn>
              <v-btn
                class="ml-2"
                color="warning"
                @click="(stepPosition = 1), (simulacaoRealizada = false)"
              >
                Voltar
              </v-btn>

              <!-- <v-btn
                text
                @click="fechaFinanciamento(), (stepPosition = 1)"
                class="ml-2"
              >
                Cancelar
              </v-btn> -->
            </v-stepper-content>

            <v-stepper-content step="3">
              <div v-if="stepPosition === 3">
                <div class="mb-4">
                  <!-- Dados Financiamento Pessoa Física -->
                  <div v-if="cliente.pessoaFisica">
                    <v-form lazy-validation ref="capturaDadosPF">
                      <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h1 style="font-size: 1.4rem" class="mt-2">
                              Informações pessoais
                            </h1>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <label class="label" style="font-size: 0.95rem"
                              >Nome</label
                            >
                            <v-text-field
                              color="black"
                              v-model="cliente.nome"
                              outlined
                              :rules="[
                                () => !!cliente.nome || 'Nome não preenchido',
                              ]"
                              required
                            ></v-text-field>
                            <label class="label" style="font-size: 0.95rem"
                              >Tipo de documento</label
                            >
                            <v-select
                              v-model="tipoDocumentoSelecionado"
                              @change="verificaTipoDocSelecionado()"
                              :items="documentTypes"
                              item-value="id"
                              item-text="description"
                              return-object
                              :rules="[
                                () =>
                                  !!tipoDocumentoSelecionado.id ||
                                  'Tipo de documento não selecionado',
                              ]"
                              required
                              outlined
                            ></v-select>
                            <div class="row">
                              <div class="col" style="padding-botton: 0">
                                <label class="label" style="font-size: 0.95rem"
                                  >Nº do documento</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.identidade"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.identidade ||
                                      'Nº de documento não preenchido',
                                  ]"
                                ></v-text-field>
                              </div>
                              <!-- <div class="col" style="padding-botton: 0">
                                <label class="label" style="font-size: 0.95rem"
                                  >Órgão emissor do documento</label
                                >
                                <v-text-field
                                  v-model="cliente.orgaoEmissor"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.orgaoEmissor ||
                                      'Órgão emissor não preenchido',
                                  ]"
                                ></v-text-field>
                              </div> -->
                            </div>

                            <div class="row">
                              <div class="col" style="padding-top: 0">
                                <label class="label" style="font-size: 0.95rem"
                                  >UF do órgão emissor</label
                                >
                                <v-select
                                  v-model="ufDocumento"
                                  :items="states"
                                  item-value="id"
                                  item-text="id"
                                  return-object
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!ufDocumento.id ||
                                      'UF do órgão emissor não preenchido',
                                  ]"
                                ></v-select>
                              </div>
                              <!-- <div class="col" style="padding-top: 0">
                                <label class="label" style="font-size: 0.95rem"
                                  >Data de emissão do documento</label
                                > -->
                                <!-- Date - Picker (Data de Emissao Documento) -->
                                <!-- <v-menu
                                  ref="controlDateEmissaoDoc"
                                  v-model="controlDateEmissaoDoc"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      outlined
                                      readonly
                                      single-line
                                      label="Clique para selecionar a data"
                                      v-model="dataEmissaoDocForm"
                                      persistent-hint
                                      v-bind="attrs"
                                      v-on="on"
                                      required
                                      :rules="[
                                        () =>
                                          !!dataEmissaoDocForm ||
                                          'Data não selecionada',
                                      ]"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    @change="verificaAlteracaoDados()"
                                    locale="pt-BR"
                                    v-model="dataEmissaoDoc"
                                    :show-current="false"
                                    no-title
                                    @input="controlDateEmissaoDoc = false"
                                  ></v-date-picker>
                                </v-menu>
                              </div> -->
                            </div>
                            <label class="label" style="font-size: 0.95rem"
                              >Sexo</label
                            >
                            <v-select
                              v-model="sexoSelecionado"
                              :items="genders"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!sexoSelecionado.id ||
                                  'Sexo não selecionado',
                              ]"
                            ></v-select>
                            <!-- <label class="label" style="font-size: 0.95rem"
                              >Estado de nascimento</label
                            >
                            <v-select
                              @change="buscaCidades()"
                              v-model="cliente.estadoNascimento"
                              :items="states"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.estadoNascimento.id ||
                                  'Estado de nascimento não selecionado',
                              ]"
                            ></v-select> -->
                            <!-- <label class="label" style="font-size: 0.95rem"
                              >Cidade de nascimento</label
                            >
                            <v-select
                              v-model="cliente.cidadeNascimento"
                              :items="cities"
                              item-value="id"
                              item-text="description"
                              return-object
                              :disabled="cliente.estadoNascimento.id == null"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.cidadeNascimento.id ||
                                  'Cidade de nascimento não selecionada',
                              ]"
                            ></v-select> -->
                            <label class="label" style="font-size: 0.95rem"
                              >Nacionalidade</label
                            >
                            <v-select
                              v-model="nacionalidadeSelecionada"
                              :items="nationality"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  typeof nacionalidadeSelecionada === 'string'
                                    ? !!nacionalidadeSelecionada
                                    : !!nacionalidadeSelecionada.id ||
                                      'Nacionalidade não selecionada',
                              ]"
                            ></v-select>
                            <!-- <label class="label" style="font-size: 0.95rem"
                              >Profissão</label
                            >
                            <v-select
                              v-model="profissaoSelecionada"
                              :items="roles"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!profissaoSelecionada.id ||
                                  'Profissão não selecionada',
                              ]"
                            ></v-select> -->
                            <div class="row">
                              <!-- <div class="col">
                                <label class="label" style="font-size: 0.95rem"
                                  >Patrimônio</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.patrimonio"
                                  v-money="money"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.patrimonio ||
                                      'Patrimônio não preenchido',
                                  ]"
                                ></v-text-field>
                              </div> -->
                              <div class="col">
                                <label class="label" style="font-size: 0.95rem"
                                  >Renda mensal</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.rendaMensal"
                                  v-money="money"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.rendaMensal ||
                                      'Renda mensal não preenchida',
                                  ]"
                                ></v-text-field>
                              </div>
                            </div>
                            <label class="label" style="font-size: 0.95rem"
                              >E-mail</label
                            >
                            <v-text-field
                              color="black"
                              v-model="cliente.email"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.email || 'E-mail não preenchido',
                              ]"
                            ></v-text-field>
                            <div class="row">
                              <div class="col-2">
                                <div>
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >DDD</label
                                  >
                                </div>
                                <v-text-field
                                  color="black"
                                  v-model="cliente.ddd"
                                  maxlength="2"
                                  outlined
                                  required
                                  :rules="[() => !!cliente.ddd || '']"
                                ></v-text-field>
                              </div>
                              <div class="col">
                                <div>
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Celular</label
                                  >
                                </div>
                                <v-text-field
                                  color="black"
                                  v-model="cliente.telefone"
                                  v-mask="'#####-####'"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.telefone ||
                                      'Número não preenchido',
                                  ]"
                                ></v-text-field>
                              </div>
                            </div>
                            <label class="label" style="font-size: 0.95rem"
                              >Nome da mãe</label
                            >
                            <v-text-field
                              color="black"
                              v-model="cliente.nomeMae"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.nomeMae ||
                                  'Nome da mãe não preenchido',
                              ]"
                            ></v-text-field>
                            <!-- <label class="label" style="font-size: 0.95rem"
                              >Estado civil</label
                            >
                            <v-select
                              v-model="estadoCivilSelecionado"
                              :items="maritalStatus"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              :rules="[
                                () =>
                                  !!estadoCivilSelecionado.id ||
                                  'Estado civil não selecionado',
                              ]"
                            ></v-select>
                            <div
                              v-if="
                                estadoCivilSelecionado.id == '1' ||
                                estadoCivilSelecionado.id == '11'
                              "
                            >
                              <br />
                              <h1 style="font-size: 1.4rem">
                                Informações do cônjuge ou companheiro
                              </h1>
                              <label class="label" style="font-size: 0.95rem"
                                >Nome</label
                              >
                              <v-text-field
                                v-model="cliente.conjugue.nome"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.conjugue.nome ||
                                    'Nome não preenchido',
                                ]"
                              ></v-text-field>
                              <label class="label" style="font-size: 0.95rem"
                                >Documento</label
                              >
                              <v-text-field
                                v-model="cliente.conjugue.documento"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.conjugue.documento ||
                                    'Documento não preenchido',
                                ]"
                              ></v-text-field>
                            </div> -->
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h1 style="font-size: 1.4rem" class="mt-2">
                              Informações residenciais
                            </h1>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <label class="label" style="font-size: 0.95rem"
                              >CEP</label
                            >
                            <v-text-field
                              color="black"
                              @change="buscaEnderecoCEP()"
                              v-model="cliente.endereco.cep"
                              v-mask="'#####-###'"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.endereco.cep ||
                                  'CEP não preenchido',
                              ]"
                            ></v-text-field>
                            <label class="label" style="font-size: 0.95rem"
                              >Endereço</label
                            >
                            <v-text-field
                              color="black"
                              v-model="cliente.endereco.logradouro"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.endereco.logradouro ||
                                  'Endereço não preenchido',
                              ]"
                            ></v-text-field>
                            <div class="row" style="margin-top: 0px">
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Número</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.endereco.numero"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.endereco.numero ||
                                      'Número não preenchido',
                                  ]"
                                ></v-text-field>
                              </div>
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Complemento</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.endereco.complemento"
                                  outlined
                                ></v-text-field>
                              </div>
                            </div>
                            <label class="label" style="font-size: 0.95rem"
                              >Bairro</label
                            >
                            <v-text-field
                              color="black"
                              v-model="cliente.endereco.bairro"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!cliente.endereco.bairro ||
                                  'Bairro não preenchido',
                                v =>
                                  (v || '').length <= 20 ||
                                  `Quantidade máxima de caracteres ${20}`
                              ]"
                            ></v-text-field>
                            <div class="row" style="margin-top: 0px">
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Estado</label
                                >
                                <v-select
                                  @change="buscaCidadeCliente()"
                                  v-model="cliente.endereco.estado"
                                  :items="states"
                                  item-text="description"
                                  item-value="id"
                                  return-object
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      typeof cliente.endereco.estado == 'string'
                                        ? !!cliente.endereco.estado
                                        : !!cliente.endereco.estado.id ||
                                          'Estado não selecionado',
                                  ]"
                                ></v-select>
                              </div>
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Cidade</label
                                >
                                <v-select
                                  v-model="cliente.endereco.cidade"
                                  :items="citiesAddress"
                                  item-value="id"
                                  item-text="description"
                                  return-object
                                  outlined
                                  :disabled="
                                    typeof cliente.endereco.estado == 'string'
                                      ? !cliente.endereco.estado
                                      : !cliente.endereco.estado.id
                                  "
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.endereco.cidade ||
                                      'Cidade não selecionada',
                                  ]"
                                ></v-select>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- <v-expansion-panel>
                            <v-expansion-panel-header>
                            <h1 style="font-size: 1.4rem" class="mt-2">
                                Informações adicionais
                            </h1>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                            sed do eiusmod tempor incididunt ut labore et dolore magna
                            aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                            ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            </v-expansion-panel-content>
                        </v-expansion-panel> -->
                      </v-expansion-panels>
                    </v-form>
                  </div>

                  <!-- Dados Financiamento Pessoa Juridica -->
                  <div v-else>
                    <v-form lazy-validation ref="capturaDadosPJ">
                      <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h1 style="font-size: 1.4rem" class="mt-2">
                              Informações da Empresa
                            </h1>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <label class="label" style="font-size: 0.95rem"
                              >Razão Social</label
                            >
                            <v-text-field
                              color="black"
                              outlined
                              v-model="empresa.nome"
                              required
                              :rules="[
                                () => !!empresa.nome || 'Nome não preenchido',
                              ]"
                            ></v-text-field>
                            <!-- <label class="label" style="font-size: 0.95rem"
                              >Porte da empresa</label
                            >
                            <v-select
                              v-model="empresa.porteEmpresa"
                              :items="companySize"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!empresa.porteEmpresa.id ||
                                  'Porte não selecionado',
                              ]"
                            ></v-select> -->
                            <label class="label" style="font-size: 0.95rem"
                              >Natureza Jurídica</label
                            >
                            <v-select
                              v-model="empresa.naturezaJuridica"
                              :items="legalNature"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!empresa.naturezaJuridica.id ||
                                  'Natureza Jurídica não selecionada',
                              ]"
                            ></v-select>
                            <div class="row" style="margin-top: 0px">
                              <div
                                class="col-2"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >DDD</label
                                >
                                <v-text-field
                                  color="black"
                                  outlined
                                  maxlength="2"
                                  v-model="empresa.ddd"
                                  required
                                  :rules="[() => !!empresa.ddd || '']"
                                ></v-text-field>
                              </div>
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Telefone</label
                                >
                                <v-text-field
                                  color="black"
                                  outlined
                                  v-model="empresa.numero"
                                  v-mask="phoneMask"
                                  @focus="focusPhone()"
                                  @blur="blurPhone()"
                                  required
                                  :rules="[
                                    () =>
                                      !!empresa.numero ||
                                      'Número não preenchido',
                                  ]"
                                ></v-text-field>
                              </div>
                            </div>
                            <label class="label" style="font-size: 0.95rem"
                              >E-mail</label
                            >
                            <v-text-field
                              color="black"
                              outlined
                              v-model="empresa.email"
                              required
                              :rules="[
                                () =>
                                  !!empresa.email || 'E-mail não preenchido',
                              ]"
                            ></v-text-field>

                            <label class="label" style="font-size: 0.95rem"
                              >Grupo atividade econômica</label
                            >
                            <v-select
                              v-model="empresa.grupoEconomico"
                              :items="economicActivityGroup"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              @change="buscaAtividadeEconomica()"
                              required
                              :rules="[
                                () =>
                                  !!empresa.grupoEconomico.id ||
                                  'Grupo não selecionado',
                              ]"
                            ></v-select>

                            <label class="label" style="font-size: 0.95rem"
                              >Atividade Econômica</label
                            >
                            <v-select
                              v-model="empresa.atividadeEconomica"
                              :items="economicActivity"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              :disabled="empresa.grupoEconomico.id == null"
                              required
                              :rules="[
                                () =>
                                  !!empresa.atividadeEconomica.id ||
                                  'Atividade Econômica não selecionada',
                              ]"
                            ></v-select>

                            <label class="label" style="font-size: 0.95rem"
                              >Faturamento mensal</label
                            >
                            <v-text-field
                              color="black"
                              outlined
                              v-money="money"
                              v-model="empresa.faturamentoMensal"
                              required
                              :rules="[
                                () =>
                                  !!empresa.faturamentoMensal ||
                                  'Faturamento mensal não preenchido',
                              ]"
                            ></v-text-field>

                            <label class="label" style="font-size: 0.95rem">
                              Tipo do relacionamento do comprador com a
                              empresa</label
                            >
                            <v-select
                              v-model="empresa.tipoRelacionamento"
                              :items="relationshipTypeCompany"
                              item-value="id"
                              item-text="description"
                              return-object
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!empresa.tipoRelacionamento.id ||
                                  'Tipo do relacionamento não selecionado',
                              ]"
                            ></v-select>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h1 style="font-size: 1.4rem" class="mt-2">
                              Informações de Endereço
                            </h1>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <label class="label" style="font-size: 0.95rem"
                              >CEP</label
                            >
                            <v-text-field
                              color="black"
                              @change="buscaEnderecoCEP(true)"
                              v-model="empresa.endereco.cep"
                              v-mask="'#####-###'"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!empresa.endereco.cep ||
                                  'CEP não preenchido',
                              ]"
                            ></v-text-field>
                            <label class="label" style="font-size: 0.95rem"
                              >Endereço</label
                            >
                            <v-text-field
                              color="black"
                              v-model="empresa.endereco.logradouro"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!empresa.endereco.logradouro ||
                                  'Endereço não preenchido',
                              ]"
                            ></v-text-field>
                            <div class="row" style="margin-top: 0px">
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Número</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="empresa.endereco.numero"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!empresa.endereco.numero ||
                                      'Número não preenchido',
                                  ]"
                                ></v-text-field>
                              </div>
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Complemento</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="empresa.endereco.complemento"
                                  outlined
                                ></v-text-field>
                              </div>
                            </div>
                            <label class="label" style="font-size: 0.95rem"
                              >Bairro</label
                            >
                            <v-text-field
                              color="black"
                              v-model="empresa.endereco.bairro"
                              outlined
                              required
                              :rules="[
                                () =>
                                  !!empresa.endereco.bairro ||
                                  'Bairro não preenchido',
                                v =>
                                  (v || '').length <= 20 ||
                                  `Quantidade máxima de caracteres ${20}`
                              ]"
                            ></v-text-field>
                            <div class="row" style="margin-top: 0px">
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Estado</label
                                >
                                <v-select
                                  @change="buscaCidadeCliente(true)"
                                  v-model="empresa.endereco.estado"
                                  :items="states"
                                  item-text="description"
                                  item-value="id"
                                  return-object
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      typeof empresa.endereco.estado == 'string'
                                        ? !!empresa.endereco.estado
                                        : !!empresa.endereco.estado.id ||
                                          'Estado não selecionado',
                                  ]"
                                ></v-select>
                              </div>
                              <div
                                class="col"
                                style="padding-top: 0; padding-bottom: 0"
                              >
                                <label class="label" style="font-size: 0.95rem"
                                  >Cidade</label
                                >
                                <v-select
                                  v-model="empresa.endereco.cidade"
                                  :items="citiesAddressCompany"
                                  item-value="id"
                                  item-text="description"
                                  return-object
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!empresa.endereco.cidade ||
                                      'Cidade não selecionada',
                                  ]"
                                ></v-select>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h1 style="font-size: 1.4rem" class="mt-2">
                              Referências Bancárias
                            </h1>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <label class="label" style="font-size: 0.95rem"
                              >Código do banco</label
                            >
                            <v-text-field
                              v-model="refBancaria.codigoBanco"
                              :rules="[
                                () =>
                                  !!refBancaria.codigoBanco ||
                                  'Código do banco não preenchido',
                              ]"
                              outlined
                              required
                            ></v-text-field>
                            <label class="label" style="font-size: 0.95rem"
                              >Código da agência</label
                            >
                            <v-text-field
                              v-model="refBancaria.codigoAgencia"
                              :rules="[
                                () =>
                                  !!refBancaria.codigoAgencia ||
                                  'Código da agência não preenchido',
                              ]"
                              outlined
                              required
                            ></v-text-field>

                            <div class="row">
                              <div class="col">
                                <label class="label" style="font-size: 0.95rem"
                                  >Conta</label
                                >
                                <v-text-field
                                  v-model="refBancaria.codigoConta"
                                  :rules="[
                                    () =>
                                      !!refBancaria.codigoConta ||
                                      'Conta não preenchida',
                                  ]"
                                  outlined
                                  required
                                ></v-text-field>
                              </div>
                              <div class="col">
                                <label class="label" style="font-size: 0.95rem"
                                  >Dígito</label
                                >
                                <v-text-field
                                  v-model="refBancaria.digitoConta"
                                  :rules="[
                                    () =>
                                      !!refBancaria.digitoConta ||
                                      'Dígito da conta não preenchido',
                                  ]"
                                  outlined
                                  required
                                ></v-text-field>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel> -->
                      </v-expansion-panels>
                      <!-- Dados do AVALISTA -->
                      <v-card elevation="8" class="mt-5 mb-5 ml-2 mr-2 pa-4">
                        <h1 style="font-size: 1.4rem">Avalista</h1>
                        <div>Insira as informações de um avalista.</div>
                        <v-expansion-panels
                          v-model="panelAvalista"
                          class="mt-2"
                        >
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <h1 style="font-size: 1.4rem" class="mt-2">
                                Informações Pessoais
                              </h1>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <label class="label" style="font-size: 0.95rem"
                                >Nome</label
                              >
                              <v-text-field
                                color="black"
                                v-model="cliente.nome"
                                outlined
                                required
                                :rules="[
                                  () => !!cliente.nome || 'Nome não preenchido',
                                ]"
                              ></v-text-field>
                              <div>
                                <label class="label" style="font-size: 0.95rem">
                                  Data de Nascimento
                                </label>
                              </div>
                              <div>
                                <v-text-field
                                  color="black"
                                  outlined
                                  v-mask="'##/##/####'"
                                  v-model="dataNascForm"
                                  :rules="[
                                    () =>
                                      !!dataNascForm ||
                                      'Campo não preenchido',
                                  ]"
                                  persistent-hint
                                ></v-text-field>
                                <!-- Date - Picker (Data de Nascimento / Fundação) -->
                                <!-- <v-menu
                                  ref="controlDateNasc"
                                  v-model="controlDateNasc"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      outlined
                                      readonly
                                      single-line
                                      label="Clique para selecionar a data"
                                      v-model="dataNascForm"
                                      :rules="[
                                        () =>
                                          !!dataNascForm ||
                                          'Campo não preenchido',
                                      ]"
                                      persistent-hint
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    :show-current="false"
                                    locale="pt-BR"
                                    v-model="dataNasc"
                                    no-title
                                    @input="controlDateNasc = false"
                                  ></v-date-picker>
                                </v-menu> -->
                              </div>
                              <label class="label" style="font-size: 0.95rem"
                                >CPF</label
                              >
                              <v-text-field
                                color="black"
                                v-model="cliente.cpf"
                                v-mask="'###.###.###-##'"
                                outlined
                                required
                                :rules="[
                                  () => !!cliente.cpf || 'CPF não preenchido',
                                ]"
                              ></v-text-field>
                              <label class="label" style="font-size: 0.95rem"
                                >Tipo de documento</label
                              >
                              <v-select
                                v-model="tipoDocumentoSelecionado"
                                @change="verificaTipoDocSelecionado()"
                                :items="documentTypes"
                                item-value="id"
                                item-text="description"
                                return-object
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!tipoDocumentoSelecionado.id ||
                                    'Tipo de documento não selecionado',
                                ]"
                              ></v-select>
                              <div class="row">
                                <div class="col" style="padding-botton: 0">
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Nº do documento</label
                                  >
                                  <v-text-field
                                    color="black"
                                    v-model="cliente.identidade"
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!cliente.identidade ||
                                        'Documento não preenchido',
                                    ]"
                                  ></v-text-field>
                                </div>
                                <!-- <div class="col" style="padding-botton: 0">
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Órgão emissor do documento</label
                                  >
                                  <v-text-field
                                    v-model="cliente.orgaoEmissor"
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!cliente.identidade ||
                                        'Órgão emissor não preenchido',
                                    ]"
                                  ></v-text-field>
                                </div> -->
                              </div>

                              <div class="row">
                                <div class="col" style="padding-top: 0">
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >UF do órgão emissor</label
                                  >
                                  <v-select
                                    v-model="ufDocumento"
                                    :items="states"
                                    item-value="id"
                                    item-text="id"
                                    return-object
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!ufDocumento.id ||
                                        'UF não selecionada',
                                    ]"
                                  ></v-select>
                                </div>
                                <!-- <div class="col" style="padding-top: 0"> -->
                                  <!-- <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Data de emissão do documento</label
                                  >
                                  <v-text-field
                                    outlined
                                    v-model="dataEmissaoDocForm"
                                    v-mask="'##/##/####'"
                                    persistent-hint
                                    v-bind="attrs"
                                    v-on="on"
                                    required
                                    :rules="[
                                      () =>
                                        !!dataEmissaoDocForm ||
                                        'Data não selecionada',
                                    ]"
                                  ></v-text-field> -->
                                  <!-- Date - Picker (Data de Emissao Documento) -->
                                  <!-- <v-menu
                                    ref="controlDateEmissaoDoc"
                                    v-model="controlDateEmissaoDoc"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        outlined
                                        readonly
                                        single-line
                                        label="Clique para selecionar a data"
                                        v-model="dataEmissaoDocForm"
                                        persistent-hint
                                        v-bind="attrs"
                                        v-on="on"
                                        required
                                        :rules="[
                                          () =>
                                            !!dataEmissaoDocForm ||
                                            'Data não selecionada',
                                        ]"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      @change="verificaAlteracaoDados()"
                                      locale="pt-BR"
                                      v-model="dataEmissaoDoc"
                                      :show-current="false"
                                      no-title
                                      @input="controlDateEmissaoDoc = false"
                                    ></v-date-picker>
                                  </v-menu> -->
                                <!-- </div> -->
                              </div>
                              <label class="label" style="font-size: 0.95rem"
                                >Sexo</label
                              >
                              <v-select
                                v-model="sexoSelecionado"
                                :items="genders"
                                item-value="id"
                                item-text="description"
                                return-object
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!sexoSelecionado.id ||
                                    'Sexo não selecionado',
                                ]"
                              ></v-select>
                              <!-- <label class="label" style="font-size: 0.95rem"
                                >Estado de nascimento</label
                              >
                              <v-select
                                @change="buscaCidades()"
                                v-model="cliente.estadoNascimento"
                                :items="states"
                                item-value="id"
                                item-text="description"
                                return-object
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.estadoNascimento.id ||
                                    'Estado não selecionado',
                                ]"
                              ></v-select> -->
                              <!-- <label class="label" style="font-size: 0.95rem"
                                >Cidade de nascimento</label
                              >
                              <v-select
                                v-model="cliente.cidadeNascimento"
                                :items="cities"
                                item-value="id"
                                item-text="description"
                                return-object
                                :disabled="cliente.estadoNascimento.id == null"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.cidadeNascimento.id ||
                                    'Cidade não selecionado',
                                ]"
                              ></v-select> -->
                              <label class="label" style="font-size: 0.95rem"
                                >Nacionalidade</label
                              >
                              <v-select
                                v-model="nacionalidadeSelecionada"
                                :items="nationality"
                                item-value="id"
                                item-text="description"
                                return-object
                                outlined
                                required
                                :rules="[
                                  () =>
                                    typeof nacionalidadeSelecionada === 'string'
                                      ? !!nacionalidadeSelecionada
                                      : !!nacionalidadeSelecionada.id ||
                                        'Nacionalidade não selecionada',
                                ]"
                              ></v-select>
                              <!-- <label class="label" style="font-size: 0.95rem"
                                >Profissão</label
                              >
                              <v-select
                                v-model="profissaoSelecionada"
                                :items="roles"
                                item-value="id"
                                item-text="description"
                                return-object
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!profissaoSelecionada.id ||
                                    'Profissão não selecionada',
                                ]"
                              ></v-select> -->
                              <div class="row">
                                <!-- <div class="col">
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Patrimônio</label
                                  >
                                  <v-text-field
                                    color="black"
                                    v-model="cliente.patrimonio"
                                    v-money="money"
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!cliente.patrimonio ||
                                        'Patrimônio não preenchido',
                                    ]"
                                  ></v-text-field>
                                </div> -->
                                <div class="col">
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Renda mensal</label
                                  >
                                  <v-text-field
                                    color="black"
                                    v-model="cliente.rendaMensal"
                                    v-money="money"
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!cliente.rendaMensal ||
                                        'Renda não preenchida',
                                    ]"
                                  ></v-text-field>
                                </div>
                              </div>
                              <label class="label" style="font-size: 0.95rem"
                                >E-mail</label
                              >
                              <v-text-field
                                color="black"
                                v-model="cliente.email"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.email || 'E-mail não preenchido',
                                ]"
                              ></v-text-field>
                              <div class="row">
                                <div class="col-2">
                                  <div>
                                    <label
                                      class="label"
                                      style="font-size: 0.95rem"
                                      >DDD</label
                                    >
                                  </div>
                                  <v-text-field
                                    color="black"
                                    v-model="avalista.telefone.ddd"
                                    maxlength="2"
                                    outlined
                                    required
                                    :rules="[() => !!avalista.telefone.ddd || '']"
                                  ></v-text-field>
                                </div>
                                <div class="col">
                                  <div>
                                    <label
                                      class="label"
                                      style="font-size: 0.95rem"
                                      >Celular</label
                                    >
                                  </div>
                                  <v-text-field
                                    color="black"
                                    v-model="avalista.telefone.numero"
                                    v-mask="'#####-####'"
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!avalista.telefone.numero ||
                                        'Telefone não preenchido',
                                    ]"
                                  ></v-text-field>
                                </div>
                              </div>
                              <label class="label" style="font-size: 0.95rem"
                                >Nome da mãe</label
                              >
                              <v-text-field
                                color="black"
                                v-model="cliente.nomeMae"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.nomeMae ||
                                    'Nome da mãe não preenchido',
                                ]"
                              ></v-text-field>
                              <label class="label" style="font-size: 0.95rem"
                                >Estado civil</label
                              >
                              <v-select
                                v-model="estadoCivilSelecionado"
                                :items="maritalStatus"
                                item-value="id"
                                item-text="description"
                                return-object
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!estadoCivilSelecionado.id ||
                                    'Estado civil não selecionado',
                                ]"
                              ></v-select>
                              <div
                                v-if="
                                  estadoCivilSelecionado.id == '1' ||
                                  estadoCivilSelecionado.id == '11'
                                "
                              >
                                <br />
                                <h1 style="font-size: 1.4rem">
                                  Informações do cônjuge ou companheiro
                                </h1>
                                <label class="label" style="font-size: 0.95rem"
                                  >Nome</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.conjugue.nome"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.conjugue.nome ||
                                      'Nome não preenchido',
                                  ]"
                                ></v-text-field>
                                <label class="label" style="font-size: 0.95rem"
                                  >Documento</label
                                >
                                <v-text-field
                                  color="black"
                                  v-model="cliente.conjugue.documento"
                                  outlined
                                  required
                                  :rules="[
                                    () =>
                                      !!cliente.conjugue.documento ||
                                      'Documento não preenchido',
                                  ]"
                                ></v-text-field>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <h1 style="font-size: 1.4rem" class="mt-2">
                                Informações Residenciais
                              </h1>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <label class="label" style="font-size: 0.95rem"
                                >CEP</label
                              >
                              <v-text-field
                                color="black"
                                @change="buscaEnderecoCEP()"
                                v-model="cliente.endereco.cep"
                                v-mask="'#####-###'"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.endereco.cep ||
                                    'CEP não preenchido',
                                ]"
                              ></v-text-field>
                              <label class="label" style="font-size: 0.95rem"
                                >Endereço</label
                              >
                              <v-text-field
                                color="black"
                                v-model="cliente.endereco.logradouro"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.endereco.logradouro ||
                                    'Endereço não preenchido',
                                ]"
                              ></v-text-field>
                              <div class="row" style="margin-top: 0px">
                                <div
                                  class="col"
                                  style="padding-top: 0; padding-bottom: 0"
                                >
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Número</label
                                  >
                                  <v-text-field
                                    color="black"
                                    v-model="cliente.endereco.numero"
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!cliente.endereco.numero ||
                                        'Número não preenchido',
                                    ]"
                                  ></v-text-field>
                                </div>
                                <div
                                  class="col"
                                  style="padding-top: 0; padding-bottom: 0"
                                >
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Complemento</label
                                  >
                                  <v-text-field
                                    color="black"
                                    v-model="cliente.endereco.complemento"
                                    outlined
                                    required
                                  ></v-text-field>
                                </div>
                              </div>
                              <label class="label" style="font-size: 0.95rem"
                                >Bairro</label
                              >
                              <v-text-field
                                color="black"
                                v-model="cliente.endereco.bairro"
                                outlined
                                required
                                :rules="[
                                  () =>
                                    !!cliente.endereco.bairro ||
                                    'Bairro não preenchido',
                                  v =>
                                    (v || '').length <= 20 ||
                                    `Quantidade máxima de caracteres ${20}`
                                ]"
                              ></v-text-field>
                              <div class="row" style="margin-top: 0px">
                                <div
                                  class="col"
                                  style="padding-top: 0; padding-bottom: 0"
                                >
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Estado</label
                                  >
                                  <v-select
                                    @change="buscaCidadeCliente()"
                                    v-model="cliente.endereco.estado"
                                    :items="states"
                                    item-text="description"
                                    item-value="id"
                                    return-object
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        typeof cliente.endereco.estado ==
                                        'string'
                                          ? !!cliente.endereco.estado
                                          : !!cliente.endereco.estado.id ||
                                            'Estado não selecionado',
                                    ]"
                                  ></v-select>
                                </div>
                                <div
                                  class="col"
                                  style="padding-top: 0; padding-bottom: 0"
                                >
                                  <label
                                    class="label"
                                    style="font-size: 0.95rem"
                                    >Cidade</label
                                  >
                                  <v-select
                                    v-model="cliente.endereco.cidade"
                                    :items="citiesAddress"
                                    item-value="id"
                                    item-text="description"
                                    return-object
                                    outlined
                                    required
                                    :rules="[
                                      () =>
                                        !!cliente.endereco.cidade ||
                                        'Cidade não selecionada',
                                    ]"
                                  ></v-select>
                                </div>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card>
                    </v-form>
                  </div>
                </div>
              </div>
              <v-btn
                color="var(--standardGreen)"
                style="color: white"
                @click="enviaProposta()"
              >
                Continuar
              </v-btn>
              <v-btn class="ml-2" color="warning" @click="stepPosition = 2">
                Voltar
              </v-btn>

              <!-- <v-btn text @click="fechaFinanciamento(), (stepPosition = 1)">
                Cancelar
              </v-btn> -->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="var(--standardGreen)" dark>
          <v-card-text style="padding: 27px">
            Buscando dados, por favor aguarde...
            <v-progress-linear
              style="margin-top: 15px"
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cupomDialog" persistent width="400">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> Cupom </v-card-title>
          <div class="pa-7">
            <label class="label" style="font-size: 0.95rem"
              >Digite o cupom</label
            >
            <v-text-field
              color="black"
              outlined
              required
              v-model="cupomInserido"
            ></v-text-field>
          </div>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="cupomDialog = false">
              OK
            </v-btn>
            <v-btn text @click="cupomDialog = false"> Cancelar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loginDialog" persistent width="400">
        <v-card>
          <v-card-title class="text-h5" style="background: #005a64; color: white;"> Ops... </v-card-title>
          <div class="pa-7">
            Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="proposalSendDialog" persistent width="400">
        <v-card>
          <v-card-title class="text-h5" style="background: #005a64; color: white;"> Ops... </v-card-title>
          <div class="pa-7">
            Proposta já realizada!
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="finalizationDialog" persistent width="400">
        <v-card>
          <v-card-title class="text-h5" style="background: #005a64; color: white;"> Proposta enviada com sucesso! </v-card-title>
          <div class="pa-7">
            <p>Sua proposta foi enviada com sucesso.</p>
            <p>Status de Retorno: <strong :style="statusColor">{{ retornoProposta.statusDescription }}</strong></p>

            <div class="mt-4">
              <p>Acompanhe a proposta pela plataforma do Santander</p>
            </div>
            <v-btn
              class="mt-4"
              outlined
              rounded
              block
              color="#005a64"
              href="https://negocios.aceservices.accenture.com/negocios/#/login"
            >
              <v-icon left>
                mdi-bank
              </v-icon>
              Acessar plataforma Santander
            </v-btn>
            <v-btn
              class="mt-4"
              outlined
              rounded
              block
              color="#005a64"
              :href="novoLVI ?
                `https://leverosintegra.dev.br/order-detail/${this.Order}` :
                `https://www.leverosintegra.com.br/Plus/order-details.aspx?${this.Order}`"
            >
              <v-icon left>
                mdi-arrow-right-thick
              </v-icon>
              Ver pedido no Leveros Integra
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
       <v-dialog v-model="deniedSimulationDialog.active" persistent width="400">
        <v-card>
          <v-card-title class="text-h5" style="background: #005a64; color: white;"> Retorno de Identificação </v-card-title>
          <div class="pa-7">
            <p><strong>Atenção!</strong></p>
            <p>Status de Retorno: <br><strong :style="deniedSimulationDialog.statusColor">{{ deniedSimulationDialog.message }}</strong></p>

            <v-btn
              class="mt-4"
              outlined
              rounded
              block
              color="#005a64"
              :href="novoLVI ?
                `https://leverosintegra.dev.br/order-detail/${this.Order}` :
                `https://www.leverosintegra.com.br/Plus/order-details.aspx?${this.Order}`"
            >
              <v-icon left>
                mdi-arrow-right-thick
              </v-icon>
              Ver pedido no Leveros Integra
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- <div class="fixed-box">
        <img class="logo" src="https://leverosintegra.com.br/Plus/arquivos/logo-leveros.png" alt="">
      </div> -->
    </v-app>
  </section>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import { VMoney } from "v-money";

export default {
  data() {
    return {
      // Financiamento (Santander)
      UrlBaseAPI: 'https://www.leverosintegra.com.br/Map/Api/',
      // UrlBaseAPI: 'http://localhost:54015/Api/',
      novoLVI: false,
      Order: null,
      DadosPedido: null,
      ValorPedido: 0,
      phoneMask: '#########',
      User: null,
      focused: false,
      disablefinancedObjects: false,
      loading: false,
      santanderDialog: false,
      finalizationDialog: false,
      proposalSendDialog: false,
      cupomDialog: false,
      disableNacionalidade: false,
      stepPosition: 1,
      panel: 0,
      statusColor: 'color: black,',
      panelAvalista: null,
      retornoProposta: {
        proposalId: null,
        proposalExternalId: null,
        status: null,
        statusAdp: null,
        statusDescription: null,
        creationDate: null
      },
      radioOfertasSantander: {
        santanderFinan: 2,
        grupoSantander: 2,
        empresasParceiras: 2,
      },
      simulacaoRealizada: false,
      deniedSimulationDialog: {
        active: false,
        message: null,
        statusColor: null,
      },
      // Retornos API -Santander
      financedValue: null,
      releasedValue: null,
      retentionPercentage: null,
      retentitonPercentageAssets: null,
      financedObjects: [
        {
          id: null,
          description: null,
        },
      ],
      installmentAmount: [
        {
          id: null,
          description: null,
        },
      ],
      paymentForms: [
        {
          id: null,
          description: null,
        },
      ],
      uuid: null,
      accountHolder: false,
      priceTable: null,
      // Datas
      firstInstallment: {
        minimumDate: null,
        maximumDate: null,
      },
      frmPagamentoSelecionada: {
        id: null,
        description: null,
      },
      documentTypes: [
        {
          id: null,
          description: null,
        },
      ],
      states: [
        {
          id: null,
          description: null,
        },
      ],
      genders: [
        {
          id: null,
          description: null,
        },
      ],
      nationality: [
        {
          id: null,
          description: null,
        },
      ],
      roles: [
        {
          id: null,
          description: null,
        },
      ],
      maritalStatus: [
        {
          id: null,
          description: null,
        },
      ],
      cities: [
        {
          id: "",
          description: "",
        },
      ],
      citiesAddress: [
        {
          id: "",
          description: "",
        },
      ],
      citiesAddressCompany: [
        {
          id: "",
          description: "",
        },
      ],
      legalNature: [
        {
          id: null,
          description: null,
        },
      ],
      companySize: [
        {
          id: null,
          description: null,
        },
      ],
      economicActivityGroup: [
        {
          id: null,
          description: null,
        },
      ],
      relationshipTypeCompany: [
        {
          id: null,
          description: null,
        },
      ],
      economicActivity: [
        {
          id: "",
          description: "",
        },
      ],

      // DataPicker - (Data de Nascimento / Fundação)
      controlDateNascFund: null,
      dataNascFund: new Date().toISOString().substr(0, 10),
      dataNascFundForm: null,

      controlDateNasc: null,
      dataNasc: new Date().toISOString().substr(0, 10),
      dataNascForm: null,

      // DataPicker - (Data de pagamento)
      controlDatePgto: null,
      dataPgto: new Date().toISOString().substr(0, 10),
      dataPgtoForm: null,

      // DataPicker - (Data de Emissao Documento - Cliente)
      controlDateEmissaoDoc: null,
      dataEmissaoDoc: new Date().toISOString().substr(0, 10),
      dataEmissaoDocForm: null,

      // Dados Pagamento
      codigoAgencia: null,
      conta: null,
      digitoConta: null,
      cupomInserido: null,

      // Cliente Santander
      cliente: {
        cpf: null,
        identidade: null,
        nome: null,
        orgaoEmissor: 'SSP',
        patrimonio: null,
        rendaMensal: null,
        cidadeNascimento: {
          id: null,
          description: null,
        },
        estadoNascimento: {
          id: null,
          description: null,
        },
        email: null,
        nomeMae: null,
        documento: null,
        telefone: null,
        ddd: null,
        pessoaFisica: true,
        conjugue: {
          documento: null,
          nome: null,
        },
        endereco: {
          estado: {
            id: null,
            description: null,
          },
          cidade: {
            id: null,
            description: null,
          },
          bairro: null,
          logradouro: null,
          prefixo: null,
          numero: null,
          complemento: null,
          cep: null,
        },
      },

      refBancaria: {
        codigoConta: null,
        digitoConta: null,
        codigoBanco: null,
        codigoAgencia: null,
      },

      empresa: {
        nome: null,
        email: null,
        porteEmpresa: {
          id: null,
          description: null,
        },
        atividadeEconomica: {
          id: null,
          description: null,
        },
        grupoEconomico: {
          id: null,
          description: null,
        },
        naturezaJuridica: {
          id: null,
          description: null,
        },
        faturamentoMensal: null,
        tipoRelacionamento: {
          id: null,
          description: null,
        },
        ddd: null,
        numero: null,
        endereco: {
          estado: {
            id: null,
            description: null,
          },
          cidade: {
            id: null,
            description: null,
          },
          bairro: null,
          logradouro: null,
          prefixo: null,
          numero: null,
          complemento: null,
          cep: null,
        },
      },

      avalista: {
        telefone: {
          ddd: null,
          numero: null
        }
      },

      // Dados Identificação
      objetoFinanciado: {
        id: null,
        description: null,
      },
      valorEntrada: null,
      valorParcelas: null,
      quantidadeParcelas: {
        id: null,
        description: null,
      },
      tipoDocumentoSelecionado: {
        id: null,
        description: null,
      },
      ufDocumento: {
        id: null,
        description: null,
      },
      sexoSelecionado: {
        id: null,
        description: null,
      },
      nacionalidadeSelecionada: {
        id: null,
        description: null,
      },
      profissaoSelecionada: {
        id: null,
        description: null,
      },
      estadoCivilSelecionado: {
        id: null,
        description: null,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      loginDialog: false,
    };
  },
  directives: {
    mask,
    money: VMoney,
  },
  watch: {
    dataNascFundForm() {
      this.dataNascFund = this.formatDateInverse(this.dataNascFundForm);
    },
    dataEmissaoDocForm() {
      this.dataEmissaoDoc = this.formatDateInverse(this.dataEmissaoDocForm);
    },
    dataNascForm() {
      this.dataNasc = this.formatDateInverse(this.dataNascForm);
    },

    // dataNascFund() {
    //   this.dataNascFundForm = this.formatDate(this.dataNascFund);
    // },
    // dataNasc() {
    //   this.dataNascForm = this.formatDate(this.dataNasc);
    // },
    dataPgto() {
      this.dataPgtoForm = this.formatDate(this.dataPgto);
    },
    // dataEmissaoDoc() {
    //   this.dataEmissaoDocForm = this.formatDate(this.dataEmissaoDoc);
    // },
    // Responsável por atualizar a tela
    exibirDialog() {
      if (this.exibirDialog) {
        this.buscaDadosIdentificacao();
      } else {
        this.santanderDialog = false;
      }
    },
    cliente(val) {
      console.log(val);
    },
  },
  created() {

    // Recupera o Token
    this.Token = this.$route.query.Token;
    this.Order = atob(this.$route.query.Order);
    console.log(this.$route.query.NewLVI)
    if (this.$route.query.NewLVI === undefined) {
      this.novoLVI = false
    } else {
      this.novoLVI = true
    }

    // Recupera os dados do Usuário logado
    this.buscaDadosIdentificacao();
  },
  methods: {
    focusPhone() {
      this.phoneMask = '#########'
    },
    blurPhone() {
      this.phoneMask = this.empresa.numero.length > 8 ? '#####-####' : '####-####';
    },
    enviaProposta() {
      // Validaçoes
      // Validação da captura de Dados de PF
      if (this.cliente.pessoaFisica) {
        if (this.panel === undefined) {
          return (this.panel = 0);
        }
        if (this.panel == 0) {
          this.panel = 1;
          return;
        } else {
          if (!this.$refs.capturaDadosPF.validate()) {
            return alert("Ops... Dados incompletos, verifique!");
          }
        }
        // Validação para PJ
      } else {
        // Percorre as etapas de preenchimento
        if (this.panel != 2) {
          return (this.panel = this.panel == 0 ? 1 : this.panel == 1 ? 2 : 2);
        }
        if (this.panelAvalista != 1) {
          return (this.panelAvalista =
            this.panelAvalista == null ? 0 : this.panelAvalista == 0 ? 1 : 1);
        }

        if (!this.$refs.capturaDadosPJ.validate()) {
          return alert("Ops... Dados incompletos, verifique!");
        }
      }
      this.loading = true;

      // Recupera o IP
      const ip = localStorage.getItem("ip");
      let data = null;

      // Recupera dados Default
      let solteiro = this.maritalStatus.find(m => m.description.toUpperCase() === 'SOLTEIRO');
      let profissao = this.roles[0];

      // Os dados comentados do Objeto foram aleterados para dados Default
      // Prepara os dados - PF
      if (this.cliente.pessoaFisica) {
        data = {
          customer: {
            document: this.somenteNumeros(this.cliente.documento),
            dateOfBirthFoundation: this.dataNascFund,
            participationType: this.cliente.pessoaFisica ? "1" : null,
            address: {
              zipCode: this.somenteNumeros(this.cliente.endereco.cep),
              street: this.cliente.endereco.logradouro,
              number: this.cliente.endereco.numero,
              complement: this.cliente.endereco.complemento,
              neighborhood: this.cliente.endereco.bairro,
              state:
                typeof this.cliente.endereco.estado == "object"
                  ? this.cliente.endereco.estado.id
                  : this.cliente.endereco.estado,
              city:
                typeof this.cliente.endereco.cidade == "object"
                  ? this.cliente.endereco.cidade.id
                  : this.cliente.endereco.cidade,
              type: this.cliente.endereco.prefixo
                ? this.cliente.endereco.prefixo
                : "RUA",
            },
            natural: {
              // birthCity: this.cliente.cidadeNascimento.id,
              birthCity:
                typeof this.cliente.endereco.cidade == "object"
                  ? this.cliente.endereco.cidade.id
                  : this.cliente.endereco.cidade,
              // birthState: this.cliente.estadoNascimento.id,
              birthState:
                typeof this.cliente.endereco.estado == "object"
                    ? this.cliente.endereco.estado.id
                    : this.cliente.endereco.estado,
              bankReference:
                typeof this.frmPagamentoSelecionada == "object"
                  ? this.frmPagamentoSelecionada.id == 3
                  : this.frmPagamentoSelecionada == 3
                  ? {
                      accountCode: this.conta,
                      accountDigit: this.digitoConta,
                      agencyCode: this.codigoAgencia,
                    }
                  : null,
              cellphone: {
                ddd: this.cliente.ddd,
                number: this.somenteNumeros(this.cliente.telefone),
              },
              // dateOfIssue: this.dataEmissaoDoc,
              dateOfIssue: this.dataNascFund,
              documentId: this.tipoDocumentoSelecionado.id,
              documentNumber: this.somenteNumeros(this.cliente.identidade),
              documentState: this.ufDocumento.id,
              gender: this.sexoSelecionado.id,
              issuingBodyDocument: this.cliente.orgaoEmissor,
              // maritalStatus: this.estadoCivilSelecionado.id,
              maritalStatus: solteiro.id,
              monthlyIncome: parseFloat(
                this.limparNumeros(this.cliente.rendaMensal)
              ),
              mother: this.cliente.nomeMae,
              nationality:
                typeof this.nacionalidadeSelecionada == "object"
                  ? this.nacionalidadeSelecionada.id
                  : this.nacionalidadeSelecionada,
              // occupation: this.profissaoSelecionada.id,
              occupation: profissao.id,
              patrimony: 800000,
              spouse:
                this.estadoCivilSelecionado.id == "1" ||
                this.estadoCivilSelecionado.id == "11"
                  ? {
                      document: this.cliente.conjugue.documento,
                      name: this.cliente.conjugue.nome,
                    }
                  : null,
            },
            name: this.cliente.nome,
            email: this.cliente.email,
          },
          uuid: this.uuid,
          ip: ip,
        };

      // Os dados comentados do Objeto foram aleterados para dados Default
      // Prepara os dados - PJ
      } else {

        let tamEmpresa = this.companySize.find(c => c.description.toUpperCase() === 'PEQUENO');

        data = {
          customer: {
            name: this.empresa.nome,
            email: this.empresa.email,
            document: this.somenteNumeros(this.cliente.documento),
            dateOfBirthFoundation: this.dataNascFund,
            participationType: "1",
            address: {
              zipCode: this.somenteNumeros(this.empresa.endereco.cep),
              street: this.empresa.endereco.logradouro,
              number: this.empresa.endereco.numero,
              complement: this.empresa.endereco.complemento,
              neighborhood: this.empresa.endereco.bairro,
              state:
                typeof this.empresa.endereco.estado == "object"
                  ? this.empresa.endereco.estado.id
                  : this.empresa.endereco.estado,
              city:
                typeof this.empresa.endereco.cidade == "object"
                  ? this.empresa.endereco.cidade.id
                  : this.empresa.endereco.cidade,
              type: this.empresa.endereco.prefixo
                ? this.empresa.endereco.prefixo
                : "RUA",
            },
            legal: {
              bankReference: {
                accountCode: 3333,
                accountDigit: "3",
                agencyCode: 3333,
                bankCode: 33,
              },
              companySize: tamEmpresa.id,
              groupEconomicActivity: this.empresa.grupoEconomico.id,
              economicActivity: this.empresa.atividadeEconomica.id,
              legalNature: this.empresa.naturezaJuridica.id,
              monthlyInvoicing: parseFloat(
                this.limparNumeros(this.empresa.faturamentoMensal)
              ),
              phone: {
                ddd: this.empresa.ddd,
                number: this.somenteNumeros(this.empresa.numero),
              },
              relationshipType: this.empresa.tipoRelacionamento.id,
              // V-models do Cliente utilizado para o Avalista
              guarantor: {
                // birthCity: this.cliente.cidadeNascimento.id,
                birthCity:
                  typeof this.cliente.endereco.cidade == "object"
                    ? this.cliente.endereco.cidade.id
                    : this.cliente.endereco.cidade,
                // birthState: this.cliente.estadoNascimento.id,
                birthState:
                  typeof this.cliente.endereco.estado == "object"
                      ? this.cliente.endereco.estado.id
                      : this.cliente.endereco.estado,
                cellphone: {
                  ddd: this.avalista.telefone.ddd,
                  number: this.somenteNumeros(this.avalista.telefone.numero),
                },
                email: this.cliente.email,
                dateOfIssue: this.dataNasc,
                dateOfBirth: this.dataNasc,
                documentId: this.tipoDocumentoSelecionado.id,
                document: this.somenteNumeros(this.cliente.cpf),
                name: this.cliente.nome,
                documentNumber: this.somenteNumeros(this.cliente.identidade),
                documentState: this.ufDocumento.id,
                gender: this.sexoSelecionado.id,
                issuingBodyDocument: this.cliente.orgaoEmissor,
                maritalStatus: this.estadoCivilSelecionado.id,
                monthlyIncome: parseFloat(
                  this.limparNumeros(this.cliente.rendaMensal)
                ),
                mother: this.cliente.nomeMae,
                nationality:
                  typeof this.nacionalidadeSelecionada == "object"
                    ? this.nacionalidadeSelecionada.id
                    : this.nacionalidadeSelecionada,
                occupation: profissao.id,
                patrimony: 800000,
                participationType: "3",
                spouse:
                  this.estadoCivilSelecionado.id == "1" ||
                  this.estadoCivilSelecionado.id == "11"
                    ? {
                        document: this.cliente.conjugue.documento,
                        name: this.cliente.conjugue.nome,
                      }
                    : null,
                address: {
                  zipCode: this.somenteNumeros(this.cliente.endereco.cep),
                  street: this.cliente.endereco.logradouro,
                  number: this.cliente.endereco.numero,
                  complement: this.cliente.endereco.complemento,
                  neighborhood: this.cliente.endereco.bairro,
                  state:
                    typeof this.cliente.endereco.estado == "object"
                      ? this.cliente.endereco.estado.id
                      : this.cliente.endereco.estado,
                  city:
                    typeof this.cliente.endereco.cidade == "object"
                      ? this.cliente.endereco.cidade.id
                      : this.cliente.endereco.cidade,
                  type: this.cliente.endereco.prefixo
                    ? this.cliente.endereco.prefixo
                    : "RUA",
                },
              },
            },
          },
          uuid: this.uuid,
          ip: ip,
        };
      }

      axios({
        method: "post",
        url: `${this.UrlBaseAPI}Financiamento?proposalSend=true&token=${this.Token}&pedido=${this.Order}`,
        data: data,
      })
        .then((res) => {
          const data = res.data;
          this.retornoProposta.proposalId = data.proposalId
          this.retornoProposta.proposalExternalId = data.proposalExternalId
          this.retornoProposta.status = data.status
          this.retornoProposta.statusAdp = data.statusAdp
          this.retornoProposta.statusDescription = data.statusDescription
          this.retornoProposta.creationDate = data.creationDate

          this.statusColor =
            this.retornoProposta.status === 'A' ? 'color: green;' :
            this.retornoProposta.status === 'E' ? 'color: blue;' :
            this.retornoProposta.status === 'N' ? 'color: red;' :
            'color: black;';

          this.finalizationDialog = true;

          // Atualiza a tela
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
          } else {
            alert("(enviaProposta)" + (err && err.response && err.response.data ? err.response.data : err));
          }
          this.loading = false;
        });

      // Envia a requisição
    },

    verificaTipoDocSelecionado() {
      // Tratativa de Nacionalidade (Por tipo de documento Selecionado)
      let brasil = this.nationality.find(n => n.description.toUpperCase() === 'BRASIL')
      let tipoDoc = this.documentTypes.find(n => n.description.toUpperCase() === 'DOCUMENTO DE IDENTIDADE')

      if (this.tipoDocumentoSelecionado.id === tipoDoc.id) {
        this.nacionalidadeSelecionada = brasil.id;
        this.disableNacionalidade = true;
      } else {
        this.nacionalidadeSelecionada = {
          id: null,
          description: null,
        };
        this.disableNacionalidade = false;
      }
    },

    buscaDadosProposta() {
      this.loading = true;
      axios
        .get(
          `${this.UrlBaseAPI}Financiamento?proposalData=true&isPJ=${!this
            .cliente.pessoaFisica}&token=${this.Token}`
        )
        .then((res) => {
          const data = res.data;
          // Recupera os dados
          this.genders = data.genders;
          this.documentTypes = data.documentTypes;
          this.states = data.states;
          this.maritalStatus = data.maritalStatus;
          this.roles = data.roles;
          this.nationality = data.nationality;

          // Recupera dados do Cliente
          let Cliente = this.DadosPedido.dadosCliente;

          // Recupera dados de PJ
          if (!this.cliente.pessoaFisica) {
            this.legalNature = data.legalNature;
            this.companySize = data.companySize;
            this.economicActivityGroup = data.economicActivityGroup;
            this.relationshipTypeCompany = data.relationshipTypeCompany;

            if (this.novoLVI) {
              if (this.DadosPedido.telefone.length > 0) {
                this.empresa.ddd = this.DadosPedido.telefone[0].ddd;
                this.empresa.numero = this.DadosPedido.telefone[0].phone;
                this.phoneMask = this.empresa.numero.length > 8 ? '#####-####' : '####-####';
              }

              this.empresa.nome = this.DadosPedido.nome;
              this.empresa.email = this.DadosPedido.email;

              if (this.DadosPedido.endereco.length > 0) {
                this.empresa.endereco.cep = this.DadosPedido.endereco[0].postalCode;
                this.buscaEnderecoCEP(true, true);
              }
            } else {

              // Recupera Dados PJ - Proposta
              // let ClienteTelefone = this.DadosPedido.telefone[0];
              if (Cliente.telefonePrincipal) {
                this.empresa.ddd = Cliente.telefonePrincipal.DDD;
                this.empresa.numero = Cliente.telefonePrincipal.NRTelefone;
                this.phoneMask = this.empresa.numero.length > 8 ? '#####-####' : '####-####';
              }
              this.empresa.nome = Cliente.nmcliente_razao;
              this.empresa.email = Cliente.email;
              this.empresa.endereco.cep = Cliente.cep;
              this.buscaEnderecoCEP(true, true);
            }

            let rtcDefault = this.relationshipTypeCompany.filter(rtc => rtc.id === "1");
            if (rtcDefault) {
              this.empresa.tipoRelacionamento = {
                id: rtcDefault[0].id,
                description: rtcDefault[0].description
              }
            }

          // Dados PF
          } else {


            if (this.novoLVI) {
              this.cliente.nome = this.DadosPedido.nome
              this.cliente.email = this.DadosPedido.email;
              if (this.DadosPedido.endereco.length > 0) {
                this.cliente.endereco.cep = this.DadosPedido.endereco[0].postalCode;
                this.buscaEnderecoCEP(false, true);
              }

            } else {
              // Recupera os dados do Cliente - Proposta
              this.cliente.nome = Cliente.nmcliente_razao;
              this.cliente.email = Cliente.email;
              this.cliente.endereco.cep = Cliente.cep;
              this.buscaEnderecoCEP(false, true);

              let sexoCliente = this.genders.filter(g => g.id === Cliente.sexo);

              try {
                this.sexoSelecionado = {
                  id: sexoCliente[0].id,
                  description: sexoCliente[0].description
                }
              } catch {
                throw "Erro!\nValidar os dados cadastrais do cliente."
              }
            }

          }

          // Atualiza a tela
          this.loading = false;
          this.stepPosition = 3;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
          } else {
            alert("(buscaDadosProposta)" + (err && err.response && err.response.data ? err.response.data : err));
          }
          this.loading = false;
        });
    },

    verificaAlteracaoDados() {
      this.simulacaoRealizada = false;
    },

    enviaSimulacao() {
      // Valida dados - Alterna validação dependendo da forma de pagamento selecionada
      if (this.frmPagamentoSelecionada.id != 3) {
        if (!this.$refs.etapaDoisA.validate()) {
          return;
        }
      } else {
        if (
          !this.$refs.etapaDoisA.validate() ||
          !this.$refs.etapaDoisB.validate()
        ) {
          return;
        }
      }

      const notDebConta =
        typeof this.frmPagamentoSelecionada === "object"
          ? this.frmPagamentoSelecionada.id != 3
          : this.frmPagamentoSelecionada != 3;

      // Recupera os dados
      const data = {
        customer: {
          document: this.somenteNumeros(this.cliente.documento),
        },
        payment: {
          account: notDebConta ? null : this.conta,
          agency: notDebConta ? null : this.codigoAgencia,
          digit: notDebConta ? null : this.digitoConta,
          coupon: this.cupomInserido == "" ? null : this.cupomInserido,
          downPayment: parseFloat(this.limparNumeros(this.valorEntrada)),
          firstPaymentDate: this.dataPgto,
          installmentAmount: this.quantidadeParcelas.id,
          installmentValue: parseFloat(this.limparNumeros(this.valorParcelas)),
          modality: "P",
          packageNumber: null,
          paymentFormId:
            typeof this.frmPagamentoSelecionada == "object"
              ? this.frmPagamentoSelecionada.id
              : this.frmPagamentoSelecionada,
        },
        tableNumber: this.priceTable,
        uuid: this.uuid,
      };

      this.loading = true;
      axios({
        method: "post",
        url: `${this.UrlBaseAPI}Financiamento?simulationSend=true&token=${this.Token}&pedido=${this.Order}`,
        data: data,
      })
        .then((res) => {
          console.log(res);
          const data = res.data;
          // Recupera os dados
          this.releasedValue = data.simulationResponse.releasedValue;
          this.retentitonPercentageAssets =
            data.simulationResponse.retentitonPercentageAssets;
          this.retentionPercentage =
            data.simulationResponse.retentionPercentage;

          // Atualiza a tela
          this.simulacaoRealizada = true;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
          } else {
            alert("(enviaSimulacao)" + (err && err.response && err.response.data ? err.response.data : err));
          }
          this.loading = false;
        });
    },

    enviaIdentificacao() {
      // Valida dados
      if (!this.$refs.etapaUm.validate()) {
        return;
      }

      // Prepara os dados
      let data = {
        customer: {
          dateOfBirthFoundation: this.dataNascFund,
          document: this.somenteNumeros(this.cliente.documento),
          cellPhone: {
            ddd: this.cliente.ddd,
            number: this.somenteNumeros(this.cliente.telefone),
          },
        },
        purchase: {
          financedObject: this.objetoFinanciado.id,
          entryValue: parseFloat(this.limparNumeros(this.valorEntrada)),
          installmentValue: parseFloat(this.limparNumeros(this.valorParcelas)),
          installmentQuantity: this.quantidadeParcelas.id,
        },
        store: {
          name: "PROPOSTA PREANALISE",
        },
      };

      this.loading = true;
      axios({
        method: "post",
        url: `${this.UrlBaseAPI}Financiamento?identificationSend=true&token=${this.Token}&pedido=${this.Order}`,
        data: data,
      })
        .then((res) => {
          const data = res.data;
          // Recupera os dados
          this.accountHolder = data.accountHolder;
          this.uuid = data.uuid;
          this.priceTable = data.atxResponse.priceTable;
          this.paymentForms = data.atxResponse.paymentForms;
          this.firstInstallment = data.atxResponse.firstInstallment;

          // Tratativa - Remoção de forma de pagamento "Débito em conta" para não correntistas
          if (this.accountHolder === "false") {
            // Recupera o index da forma de pagamento
            var index = this.paymentForms.findIndex(
              (p) => p.description.toUpperCase() === "DEBITO EM CONTA SANTANDER"
            );
            if (index) {
              // Remove a forma de pagamento
              this.paymentForms.splice(index, 1);
            }
          }

          // Tratativa Opção débito em Conta (Correntista)
          if (this.accountHolder === "true") {
            this.frmPagamentoSelecionada = 3;
          }

          // Tratativa data de pagamento recomendada
          this.dataPgto = this.firstInstallment.recommendedDate;

          // Atualiza a tela
          this.loading = false;
          this.stepPosition = 2;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
          } else if (err && err.response && err.response.data && err.response.data.toLowerCase().includes("proposta negada")) {
            this.deniedSimulationDialog.message = err.response.data.replace('(Identification):', '');
            this.deniedSimulationDialog.statusColor = 'color: red;';
            this.deniedSimulationDialog.active = true;
          } else {
            alert("(enviaIdentificacao)" + (err && err.response && err.response.data ? err.response.data : err));
          }
          this.loading = false;
        });
    },

     async buscaDadosIdentificacao() {
      this.loading = true;
      let formaPagamento = null;
      let propostaRealizada = false;

      if (!this.novoLVI) {
        // Busca dados do pedido - LVI Antigo
        await axios
          .get(
            `${this.UrlBaseAPI}pedido/${this.Order}-token${this.Token}`
          )
          .then(res => {
            this.DadosPedido = res.data[0]
            let Cliente = this.DadosPedido.dadosCliente;
            // let ClienteTelefone = this.DadosPedido.telefone[0];

            if (this.DadosPedido.frmPagamentoIncompleta.length > 0) {
              formaPagamento = this.DadosPedido.frmPagamentoIncompleta[0];

              // Verifica se é PF
              this.cliente.pessoaFisica = Cliente.cpfcnpj.length > 11 ? false : true;
              // Inclui os dados co cliente
              this.cliente.documento = Cliente.cpfcnpj;
              this.dataNascFundForm = this.moment(Cliente.dtNascimentoFundacao).format("DD/MM/YYYY");

              if (Cliente.telefonePrincipal) {
                this.cliente.ddd = Cliente.telefonePrincipal.DDD;
                this.cliente.telefone = Cliente.telefonePrincipal.NRTelefone;
              }

              // Atualiza o valor do pedido
              this.ValorPedido = this.DadosPedido.vlliquido + this.DadosPedido.vltotalfrete;
            } else {
              propostaRealizada = true;
            }
          })
          .catch(err => {
            console.log(err)
          })

      // Busca dados no novo LVI
      } else {
        await axios.get(
          `https://leverosintegra.dev.br/api/order/getOrder/${this.Order}`,
          {
            headers: {
              token: this.Token
            }
          }
        ).then(res => {
          this.DadosPedido = res.data

          formaPagamento = this.DadosPedido.pagamento.filter(p => p.fixedPaymentMethodId === 50)[0];

          // Verifica se é PF
          this.cliente.pessoaFisica = this.DadosPedido.documento.length > 11 ? false : true;
          // Inclui os dados co cliente
          this.cliente.documento = this.DadosPedido.documento;
          // this.dataNascFundForm = this.moment(Cliente.dtNascimentoFundacao).format("DD/MM/YYYY");

          if (this.DadosPedido.telefone.length > 0) {
            let tel = this.DadosPedido.telefone[0]
            this.cliente.ddd = tel.ddd;
            this.cliente.telefone = tel.phone;
          }

          // Atualiza o valor do pedido
          this.ValorPedido = this.DadosPedido.totalComFrete

          console.log(res)
        }).catch(err => {
          alert(err.response)
        })
      }

      await axios
        .get(
          `${this.UrlBaseAPI}Financiamento?identificationData=true&token=${this.Token}`
        )
        .then((res) => {
          const data = res.data;
          // Tratativa de parcelas
          // const qtdParcelas = data.installmentAmount.description;
          let arrayParcelas = [];
          // Inclui parcelas
          arrayParcelas.push({
            id: 8,
            description: "8X",
          });
          arrayParcelas.push({
            id: 12,
            description: "12X",
          });
          arrayParcelas.push({
            id: 24,
            description: "24X",
          });
          // let i = 0;
          // for (i = 0; i < qtdParcelas; i++) {
          //   // Cria o array de parcelas
          //   arrayParcelas.push({
          //     id: i + 1,
          //     description: i + 1 + "X",
          //   });
          // }
          // Recupera os dados
          this.installmentAmount = arrayParcelas;
          this.financedObjects = data.financedObjects;

          let tratativaProduto = this.financedObjects.filter(f => f.id === 'DV')
          if (tratativaProduto.length > 0) {
            this.objetoFinanciado = {
              id: tratativaProduto[0].id,
              description: tratativaProduto[0].description
            }
            this.disablefinancedObjects = true;
          }

          // Se for novo LVI
          if (this.novoLVI) {
            let parcelaSelecionada = arrayParcelas.filter(a => a.id === parseInt(formaPagamento.paymentConditionId));
            // Atualiza a quantidade de parcelas com o retorno dos dados do cliente
            if (parcelaSelecionada) {
              this.quantidadeParcelas = {
                id: parcelaSelecionada[0].id,
                description: parcelaSelecionada[0].description
              };
            }

            // Calcula o valor de parcela
            let parcela = 0
            parcela =
              formaPagamento.paymentConditionId == 24 ? ((parseFloat(this.ValorPedido)  * 0.05115 * 24) / parseInt(formaPagamento.paymentConditionId)) :
              formaPagamento.paymentConditionId == 12 ? ((parseFloat(this.ValorPedido)  * 0.08676 * 12) / parseInt(formaPagamento.paymentConditionId)) :
              formaPagamento.paymentConditionId == 8 ? (parseFloat(this.ValorPedido) / parseInt(formaPagamento.paymentConditionId)) : 0

            parcela = parseFloat(parcela.toFixed(2))

            //Aplicando regra de juros informado pelo financeiro para 12 e 24
            // parcela = formaPagamento.paymentConditionId == 24 ? parcela * 0.04991 * 24 : formaPagamento.paymentConditionId == 12 ? parcela * 0.08653 * 12 : parcela;
            // Tratativa de atualização do campo de Parcelas
            this.$refs.valorParcelas.$el.getElementsByTagName('input')[0].value = parcela.toFixed(2);
            this.valorParcelas = parcela;


          // Se for o LVI antigo / Solar
          } else {
            let parcelaSelecionada = arrayParcelas.filter(a => a.id === parseInt(formaPagamento.nrparcela));

            // Atualiza a quantidade de parcelas com o retorno dos dados do cliente
            if (parcelaSelecionada) {
              this.quantidadeParcelas = {
                id: parcelaSelecionada[0].id,
                description: parcelaSelecionada[0].description
              };
            }

            // Calcula o valor de parcela
            let parcela = this.ValorPedido / parseInt(formaPagamento.nrparcela);
            //Aplicando regra de juros informado pelo financeiro para 12 e 24
            parcela = formaPagamento.nrparcela == 24 ? parcela * 0.04991 * 24 : formaPagamento.nrparcela == 12 ? parcela * 0.08653 * 12 : parcela;
            // Tratativa de atualização do campo de Parcelas
            this.$refs.valorParcelas.$el.getElementsByTagName('input')[0].value = parcela.toFixed(2);
            this.valorParcelas = parcela;
          }


          // Atualiza a tela
          this.loading = false;
          this.santanderDialog = true;

        })
        .catch((err) => {
          this.loading = false;
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
            this.loginDialog = true
          } else {
            if (propostaRealizada) {
               return this.proposalSendDialog = true;
            }
            alert("Erro ao buscar dados! Tente novamente");
          }
          this.fechaFinanciamento();
          console.log((err && err.response && err.response.data ? err.response.data : err));
        });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateInverse(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    // Verifica o documento inserido no Financiamento
    // verificaDocumento() {
    //   // Verifica se é PF
    //   if (this.cliente.documento) {
    //     this.cliente.pessoaFisica = this.cliente.documento.length <= 11;
    //   }
    // },

    fechaFinanciamento() {
      this.simulacaoRealizada = false;
      // this.fechaDialog(true);
    },

    buscaAtividadeEconomica() {
      this.loading = true;
      axios
        .get(
          `${this.UrlBaseAPI}Financiamento?economicActivityGroup=${this.empresa.grupoEconomico.id}&token=${this.Token}`
        )
        .then((res) => {
          // Recupera os dados
          this.economicActivity = res.data;
          // Atualiza a tela
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
          } else {
            alert("(buscaAtividadeEconomica)" + (err && err.response && err.response.data ? err.response.data : err));
          }
          this.loading = false;
        });
    },

    buscaCidadeCliente(empresa) {
      this.loading = true;
      if (
        this.cliente.endereco.estado.id != null ||
        this.empresa.endereco.estado.id != null
      ) {
        axios
          .get(
            `${this.UrlBaseAPI}Financiamento?stateUF=${
              empresa
                ? this.empresa.endereco.estado.id
                : this.cliente.endereco.estado.id
            }&token=${this.Token}`
          )
          .then((res) => {
            if (!empresa) {
              // Recupera os dados
              this.citiesAddress = res.data;
              this.cliente.endereco.cidade = null;
            } else {
              this.citiesAddressCompany = res.data;
            }
            // Atualiza a tela
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status == 401) {
              alert(
                "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
              );
            } else {
              alert("(buscaCidades)" + (err && err.response && err.response.data ? err.response.data : err));
            }
            this.loading = false;
          });
      }
    },

    buscaEnderecoCEP(empresa, buscaCaptura) {
      // Prepara os dados
      const data = {
        cep: empresa
          ? this.somenteNumeros(this.empresa.endereco.cep)
          : this.somenteNumeros(this.cliente.endereco.cep),
      };
      // Envia a requisição
      this.loading = true;
      axios({
        method: "post",
        url: `${this.UrlBaseAPI}Financiamento?token=${this.Token}&getAddressByZipCode=true`,
        data: data,
      })
        .then((res) => {
          // Recupera os dados de retorno
          const data = res.data;

          // Recupera dados do Cliente
          let Cliente = this.DadosPedido.dadosCliente ? this.DadosPedido.dadosCliente : null;

          if (!empresa) {
            this.cliente.endereco.logradouro = data.street;
            this.cliente.endereco.prefixo = data.prefix;
            this.cliente.endereco.bairro = data.district;
            this.cliente.endereco.estado = data.state;

            // Incrementa endereço do usuário cadastrado na captura de dados da Proposta
            if (buscaCaptura) {
              if (this.novoLVI) {
                if (this.DadosPedido.endereco.length > 0) {
                  this.cliente.endereco.logradouro = this.DadosPedido.endereco[0].street;
                  this.cliente.endereco.numero = this.DadosPedido.endereco[0].number;
                  this.cliente.endereco.bairro = this.DadosPedido.endereco[0].neighborhood;
                  this.cliente.endereco.complemento = this.DadosPedido.endereco[0].complement;
                }
              } else {
                this.cliente.endereco.logradouro = Cliente.logradouro;
                this.cliente.endereco.numero = Cliente.nrresidencia;
                this.cliente.endereco.bairro = Cliente.bairro;
                this.cliente.endereco.complemento = Cliente.complemento;
              }
            }

          } else {
            this.empresa.endereco.logradouro = data.street;
            this.empresa.endereco.prefixo = data.prefix;
            this.empresa.endereco.bairro = data.district;
            this.empresa.endereco.estado = data.state;

            // Incrementa endereço do usuário cadastrado na captura de dados da Proposta
            if (buscaCaptura) {
              if (this.novoLVI) {
                this.cliente.endereco.logradouro = this.DadosPedido.endereco[0].street;
                this.cliente.endereco.numero = this.DadosPedido.endereco[0].number;
                this.cliente.endereco.bairro = this.DadosPedido.endereco[0].neighborhood;
                this.cliente.endereco.complemento = this.DadosPedido.endereco[0].complement;
              } else {
                this.empresa.endereco.logradouro = Cliente.logradouro;
                this.empresa.endereco.numero = Cliente.nrresidencia;
                this.empresa.endereco.bairro = Cliente.bairro;
                this.empresa.endereco.complemento = Cliente.complemento;
              }
            }
          }
          // Busca as cidades por estado
          axios
            .get(
              `${this.UrlBaseAPI}Financiamento?stateUF=${
                empresa
                  ? this.empresa.endereco.estado
                  : this.cliente.endereco.estado
              }&token=${this.Token}`
            )
            .then((res) => {
              if (!empresa) {
                this.citiesAddress = res.data;
                this.cliente.endereco.cidade = data.countyId;
              } else {
                this.citiesAddressCompany = res.data;
                this.empresa.endereco.cidade = data.countyId;
              }
              // Atualiza a Tela
              this.loading = false;
            })
            .catch((err) => {
              if (err.response && err.response.status == 401) {
                alert(
                  "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
                );
              }
              this.loading = false;
              console.log(err);
            });
        })
        .catch((err) => {
          if (err.response && err.response.status == 401) {
            alert(
              "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
            );
          }
          console.log(err);
          this.loading = false;
        });
    },

    buscaCidades() {
      this.loading = true;
      if (this.cliente.estadoNascimento.id != null) {
        axios
          .get(
            `${this.UrlBaseAPI}Financiamento?stateUF=${this.cliente.estadoNascimento.id}&token=${this.Token}`
          )
          .then((res) => {
            // Recupera os dados
            this.cities = res.data;
            // Atualiza a tela
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status == 401) {
              alert(
                "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
              );
            } else {
              alert("(buscaCidades)" + (err && err.response && err.response.data ? err.response.data : err));
            }
            this.loading = false;
          });
      }
    },

    /**
     * Função responsável por remover carácteres dos números
     */
    somenteNumeros(str) {
      if (str) {
        let onlyNumbers = str.replace(/\D+/g, "");
        return onlyNumbers;
      }
    },

    limparNumeros(str) {
      if (str) {
        str = str.toString();
        let onlyNumbers = str.replace(/\D+/g, "");

        var inteiros = onlyNumbers.substring(0, onlyNumbers.length - 2);
        var decimais = onlyNumbers.substring(
          onlyNumbers.length - 2,
          onlyNumbers.length
        );

        var valorFormatado = `${inteiros}.${decimais}`;

        return valorFormatado;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-box {
  /* border:1px solid red;  */
  position:fixed;
  bottom:0;
  right:0;
  width:250px;
  height:100px;
}

.logo {
  width: 100%;
}

.card-financiamento {
  // width: 40%;
  width: 600px;
  align-self: center;
}
</style>
